import request from '@/utils/request'

// 分页查询客户志列表
export function listCustomer(data) {
  return request({
    url: '/crmCustomer/list',
    method: 'post',
    data: data
  })
}

// 根据客户姓名查询客户
export function queryCustomerByName(query) {
  return request({
    url: '/crmCustomer/querySimpleInfoByName',
    method: 'get',
    params: query
  })
}

// 查询所有客户简要信息
export function listSimpleAll(query) {
  return request({
    url: '/crmCustomer/listSimpleAll',
    method: 'get',
    params: query
  })
}

// 查询所有客户简要信息（有权限控制）
export function listSimpleAllWithDataPermission(query) {
  return request({
    url: '/crmCustomer/listSimpleAll2',
    method: 'get',
    params: query
  })
}

// 分页查询客户简要信息
export function listSimplePage(data) {
  return request({
    url: '/crmCustomer/listSimplePage',
    method: 'post',
    data: data
  })
}

// 分页查询客户简要信息（有权限控制）
export function listSimplePageWithAuth(data) {
  return request({
    url: '/crmCustomer/listSimplePage2',
    method: 'post',
    data: data
  })
}

// 查询客户
export function queryCustomerDetail(query) {
  return request({
    url: '/crmCustomer/detail',
    method: 'get',
    params: query
  })
}

// 新增客户
export function createCustomer(data) {
  return request({
    url: '/crmCustomer/create',
    method: 'post',
    data: data
  })
}

// 新增客户并同步新增首个联系人
export function createCustomerWithContact(data) {
  return request({
    url: '/crmCustomer/createWithContact',
    method: 'post',
    data: data
  })
}

// 更新客户
export function updateCustomer(data) {
  return request({
    url: '/crmCustomer/update',
    method: 'post',
    data: data
  })
}

// 更新客户
export function updateCustomerStatus(data) {
  return request({
    url: '/crmCustomer/updateStatus',
    method: 'post',
    data: data
  })
}
